import { ClockCountdownIcon } from '@phosphor-icons/react'
import { Handle, type NodeProps, Position, useNodeConnections, useNodeId } from '@xyflow/react'
import { cn } from 'app/lib/utils'
import { formatDuration } from 'app/lib/workflows/format'
import type { WaitUntilFlowNode } from 'app/types/workflows'
import { AppendButton } from './AppendButton'
import { NodeShell } from './NodeShell'

const HANDLE = `!h-2.5 !w-2.5 !border-2 !border-(--surface)`

/** Waits up to a time limit for the contact to match conditions, then forks. Reuses the branch
 *  `yes`/`no` handles (Met / Timed out) so the append, insert and layout logic works unchanged. */
export function WaitUntilNode({ data, selected }: NodeProps<WaitUntilFlowNode>) {
  const nodeId = useNodeId()
  const yesOpen = useNodeConnections({ handleType: `source`, handleId: `yes` }).length === 0
  const noOpen = useNodeConnections({ handleType: `source`, handleId: `no` }).length === 0
  return (
    <NodeShell
      icon={ClockCountdownIcon}
      accent="amber"
      kind="Wait until"
      label={data.label}
      description={`Up to ${formatDuration(data.duration, data.unit)}`}
      selected={selected}
      hasSource={false}
    >
      <div className="flex justify-between px-5 pb-2 text-caption-sm font-semibold">
        <span className="text-default">MET</span>
        <span className="text-minimal">TIMED OUT</span>
      </div>
      <Handle id="yes" type="source" position={Position.Bottom} className={cn(HANDLE, `!left-1/4 !bg-inverse`)} />
      <Handle id="no" type="source" position={Position.Bottom} className={cn(HANDLE, `!left-3/4 !bg-inverse/40`)} />
      {nodeId != null && yesOpen && (
        <AppendButton nodeId={nodeId} sourceHandle="yes" className="-bottom-8 left-1/4 -translate-x-1/2" />
      )}
      {nodeId != null && noOpen && (
        <AppendButton nodeId={nodeId} sourceHandle="no" className="-bottom-8 left-3/4 -translate-x-1/2" />
      )}
    </NodeShell>
  )
}
